<template>
  <div class="h-100 pt-4 pb-1">
    <div class="text-center kiosk-login-auth-box">
      <CCol>
        <h2 class="from-text kiosk-main-heading mb-0">
          {{ $t("kiosk.from") }}
        </h2></CCol
      >
      <CCol class="img-box">
        <img
          class="img"
          :src="
            activeKiosk.user.avatar
              ? activeKiosk.user.avatar
              : '/img/avatars/user-avatar.jpeg'
          "
          :alt="kioskProfilePhotoAlt"
        />
      </CCol>
      <CCol class="kiosk-login-auth-box-text">
        {{ activeKiosk.user.first_name + " " + activeKiosk.user.last_name }} ({{
          activeKiosk.room
            ? activeKiosk.room.name
            : activeKiosk.user
              ? activeKiosk.user.name
              : ""
        }})
      </CCol>
    </div>
    <CRow class="w-auto m-auto mt-3">
      <BaseButton
        data-test-id="kiosk-new-pass-button"
        class="d-flex align-items-center justify-content-center"
        solid
        rounded
        @click="setActiveTab('createPass')"
      >
        {{ $t("kiosk.new_pass") }}
      </BaseButton>
    </CRow>
    <CRow class="w-auto m-auto mt-3">
      <BaseButton
        class="d-flex align-items-center justify-content-center"
        rounded
        @click="setActiveTab('endPass')"
      >
        {{ $t("kiosk.end_pass") }}
      </BaseButton>
    </CRow>
    <div class="d-flex align-items-center justify-content-center mt-5">
      <a
        class="kiosk-terms-and-privacy-text"
        target="_blank"
        href="https://www.securly.com/terms-and-conditions"
        >{{ $t("kiosk.terms_of_use") }}</a
      >
      <span class="mx-2">|</span>
      <a
        class="kiosk-terms-and-privacy-text"
        target="_blank"
        href="https://www.securly.com/privacy"
        >{{ $t("kiosk.privacy_policy") }}</a
      >
    </div>
  </div>
</template>
<script>
import BaseButton from "@/v3components/shared/Buttons/BaseButton.vue"

export default {
  name: "KioskMainScreen",
  components: { BaseButton },
  props: ["activeKiosk"],
  emits: ["tabChanged"],
  computed: {
    kioskProfilePhotoAlt() {
      const u = this.activeKiosk?.user
      if (!u) return this.$t("kiosk.a11y_profile_photo")
      const name = [u.first_name, u.last_name].filter(Boolean).join(" ").trim()
      return name
        ? this.$t("kiosk.a11y_profile_photo_named", { name })
        : this.$t("kiosk.a11y_profile_photo")
    }
  },
  methods: {
    setActiveTab(tab) {
      this.$emit("tabChanged", tab)
    }
  }
}
</script>
